import { useCallback } from 'react'

import { LegalDocumentType, useGetActiveLegalDocumentLazyQuery } from 'generated/graphql'

interface NextVersion {
  major: number
  minor: number
  patch: number
}

export const useLatestVersion = () => {
  const [fetchActive] = useGetActiveLegalDocumentLazyQuery()

  const getNextVersion = useCallback(
    async (documentType: LegalDocumentType): Promise<NextVersion> => {
      try {
        const { data } = await fetchActive({ variables: { documentType }, fetchPolicy: 'network-only' })
        const doc = data?.activeLegalDocument

        if (doc) {
          const major = doc.versionMajor ?? 1
          const minor = doc.versionMinor ?? 0
          const patch = doc.versionPatch ?? 0
          return { major, minor, patch: patch + 1 }
        }
      } catch {
        // Ignore
      }

      return { major: 1, minor: 0, patch: 0 }
    },
    [fetchActive],
  )

  return { getNextVersion }
}
